export const TUTORIAL_AUTO_ADVANCE_SECONDS = 2;

export const TUTORIAL_MUSIC_BY_FLOW = {
  dashboard: '/tutorials/music/gcentra-dashboard-long-v1.mp3',
  logistics: '/tutorials/music/gcentra-logistics-long-v1.mp3',
  routeCreator: '/tutorials/music/gcentra-logistics-long-v1.mp3',
  service: '/tutorials/music/gcentra-dashboard-long-v1.mp3',
  monitor: '/tutorials/music/gcentra-logistics-long-v1.mp3',
  reports: '/tutorials/music/gcentra-dashboard-long-v1.mp3',
  fleetExpenses: '/tutorials/music/gcentra-dashboard-long-v1.mp3',
  stock: '/tutorials/music/gcentra-dashboard-long-v1.mp3',
  unitModal: '/tutorials/music/gcentra-dashboard-long-v1.mp3',
};

export const TUTORIAL_DEFAULT_AUDIO_HINT_TEXT = 'Subí un poco el volumen: este recorrido tiene guía por voz.';

export const TUTORIAL_SEEN_STORAGE_KEYS = {
  dashboard: 'gcentra_tutorial_inicio_seen',
  logistics: 'gcentra_tutorial_logistica_seen',
  routeCreator: 'gcentra_tutorial_route_creator_seen',
  service: 'gcentra_tutorial_service_seen',
  monitor: 'gcentra_tutorial_monitor_seen',
  reports: 'gcentra_tutorial_reports_seen',
  fleetExpenses: 'gcentra_tutorial_fleet_expenses_seen',
  stock: 'gcentra_tutorial_stock_seen',
  unitModal: 'gcentra_tutorial_unit_modal_seen',
};

export const TUTORIAL_REPEAT_STORAGE_KEYS = {
  unitModal: 'gcentra_tutorial_unit_modal_repeat',
};
